import { render, staticRenderFns } from "./TrayBadge.vue?vue&type=template&id=7444149c"
import script from "./TrayBadge.vue?vue&type=script&lang=js"
export * from "./TrayBadge.vue?vue&type=script&lang=js"
import style0 from "./TrayBadge.vue?vue&type=style&index=0&id=7444149c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports